var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 10C5.3705 10 5.2463 9.94856 5.15473 9.85699C5.06316 9.76542 5.01172 9.64122 5.01172 9.51172V0.488281C5.01172 0.358781 5.06316 0.234585 5.15473 0.143014C5.2463 0.0514438 5.3705 0 5.5 0C5.6295 0 5.7537 0.0514438 5.84527 0.143014C5.93684 0.234585 5.98828 0.358781 5.98828 0.488281V9.51172C5.98828 9.64122 5.93684 9.76542 5.84527 9.85699C5.7537 9.94856 5.6295 10 5.5 10Z",
    fill: "#E92127"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0117 5.48828H0.988281C0.858781 5.48828 0.734585 5.43684 0.643014 5.34527C0.551444 5.2537 0.5 5.1295 0.5 5C0.5 4.8705 0.551444 4.7463 0.643014 4.65473C0.734585 4.56316 0.858781 4.51172 0.988281 4.51172H10.0117C10.1412 4.51172 10.2654 4.56316 10.357 4.65473C10.4486 4.7463 10.5 4.8705 10.5 5C10.5 5.1295 10.4486 5.2537 10.357 5.34527C10.2654 5.43684 10.1412 5.48828 10.0117 5.48828Z",
    fill: "#E92127"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add-icon.31df0094727b9b5edc0cf80f468e3905.svg";
export { ForwardRef as ReactComponent };